/*
 * ====================================================================
 * Grow Template
 * @package  Grow Template
 * @author   GrowGroup.Inc <info@grow-group.jp>
 * @license  MIT Licence
 * ====================================================================
 */




(function ($) {
  var growApp = function () {

  };

  /************************
   * please insert your code
   *************************/
  growApp.prototype.myCode = function () {

  }

  growApp.prototype.toggleMenuColor = function () {
    const menu = document.querySelector(".c-slidebar-button");

    const isTopPage = document.querySelector(".c-main-visual");

    if (!menu || !isTopPage) return false;
      menu.classList.add("is-white")
  }

  growApp.prototype.showForm = function () {

    const formCheckbox = document.getElementById("form-agreement-check");
    const unvisibleForm = document.querySelector(".c-block-form-visibility");
    const visibleOption = document.querySelector(".c-block-form-agreement__option");
    // const visibleButton = document.querySelector(".c-block-form-agreement__button");

    const $mw_wp_form = $('.mw_wp_form_input');
    if ($mw_wp_form) {
      const error = $mw_wp_form.find('.error');
      const referrer  = document.referrer;
      const pattern = 'confirm';

      if (error.length > 0 || referrer.includes(pattern)) {
        if (!unvisibleForm) return;

        // $(formCheckbox).prop('checked', true);
        showForm();

        return;
      }
    }

    if (!formCheckbox || !unvisibleForm || !visibleOption) {
      return false;
    }

    formCheckbox.addEventListener("change", (e) => {

      if (!e.target.checked) {
        return false;
      }
      showForm();
    })

    function showForm() {
      visibleOption.style.display = "none";
      // visibleButton.style.display = "none";
      unvisibleForm.classList.add("is-visible");

      let speed = 500;
      let position = $(unvisibleForm).offset().top;
      $('html, body').animate({ scrollTop: position - 50 }, speed, 'swing');
    }
  }

  growApp.prototype.enterAnimation = function () {
    var $loader = document.querySelector(".c-block-loader");
    var $loaderContent = document.querySelector(".c-main-visual__content");
    var win = $(window).innerWidth();

    if (win < 950) {
      if($loader) {
        $loader.classList.add('is-secondary-hidden');
      }
      return false;
    }

    function changeClass(el, className, time) {
      return new Promise(function (resolve, reject) {
        setTimeout(function () {
          el.classList.add(className);
          resolve(className);
        }, time);
      });
    }

    var loaderFunction = function () {
      if ($loader) {

        changeClass($loaderContent, "is-move", 3500).then(function () {
          changeClass($loader, "is-hidden", 1000).then(function () {

          });
        });
      }
    }

    //first entry only
    if (!sessionStorage.getItem('loading')) {
      loaderFunction();
      enterAnimTrigger();
      sessionStorage.setItem('loading', true);
    } else if($loader){
      $loader.classList.add('is-secondary-hidden');
      $loaderContent.classList.add('is-actived');
    }

    function enterAnimTrigger() {
      let target = $('.c-block-loader');
      let owl = $('.c-main-visual__slider');
      if (sessionStorage.getItem('loading') == null) {
        $(window).on('load', function() {
          owl.trigger('stop.owl.autoplay');

          owl.delay(1000).queue(function() {
            $(this).trigger('play.owl.autoplay',[5000,5000]);
          });
        })
      } else {
        target.hide();
      }
      // localStorage.setItem('visited', true);
    }
  }

  growApp.prototype.typedJs = function () {

    var el = document.querySelector('.c-main-visual__texts');
    var el2 = document.querySelector('.is-page-header-typing');

    if(el) {
      var typed = new Typed(el, {
        strings: [ "", "<span>ICT</span>で\n暮らしを支える、\n未来を変える。"],
        typeSpeed: 80,
      });
    }

    if(el2) {
      var typed = new Typed(el2, {
        strings: [ "", "<span>アイフォーコムは、</span>\n<span>社員一人ひとりの目標実現を</span>\n<span>支援しています。</span>"],
        typeSpeed: 40,
      });
    }
  }

  growApp.prototype.animationOrigin = function (){
    $(window).scroll(function (){
      $(".is-animating").each(function(){
        var hit		= $(this).offset().top;
        var scroll	= $(window).scrollTop();
        var wHeight	= $(window).height();

        if (scroll > hit - wHeight + wHeight/2){
          $(this).addClass("is-move");
        }
      });
    });
  }

  growApp.prototype.animationUnderTyping = function (){
    var win = $(window).innerWidth();
    if (win < 950) {
      return false;
    }

    $(window).scroll(function (){
      $(".is-typing").each(function(){
        var hit		= $(this).offset().top;
        var scroll	= $(window).scrollTop();
        var wHeight	= $(window).height();
        var el = document.querySelector('.is-typing');

        if(el) {
          if (scroll > hit - wHeight + wHeight/2){
            var typed = new Typed(el, {
              strings: [ "", "<span>アイフォーコムは、</span><span>社員一人ひとりの目標実現を</span><span>支援しています。</span>"],
              typeSpeed: 50,
            });

            // スクロールして繰り返さないためにクラスを消去
            $(this).removeClass("is-typing");
          }
        }
      });
    });
  }



  $(function () {
    var app = new growApp();
    app.myCode();
    app.showForm();
    app.enterAnimation();
    app.typedJs();
    app.animationOrigin();
    app.animationUnderTyping();
    app.toggleMenuColor();
  });
})(jQuery);
